import React, { useEffect, FC } from "react";
import { Table, Button, Input, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { usePurchaseRoDetailsModel, IMaterialDetailModel } from "./purchaseRoDetailsModel";
import { ColumnsType } from "antd/lib/table";
import { YhBox } from "@/components/YhBox";
import { EditableCell, EditableRow } from "@/components/YHEditTable/editTable";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { formatNum, formatIntPoint, transPgToPagination } from "@/utils/utils";
import { ISearchPage } from '@/types/ScmTypes';
import { IPurchaseDetails } from '../../purchaseRoType';
import { purchaseRoService } from '../../purchaseRoService';
import useGlobalModel from '@/model/globalModel';
import { DictCodeEnmu, sourceAppOrBranch } from '@/types/VrmSaDictEnums';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { roleColumnModel } from "@/utils/roleColumn";
import YhTootip from "@/components/YhTootip";

enum OPT_TYPE {
    ADD = 1,
    REMOVE = 2
}
export const AddGoodsModal: FC<RouterParamType> = ({ id, mode }) => {
    const {
        addModalVisible: visible,
        initPgCfg,
        detailAddList,
        detailDataSource,
        detailAddForm,
        detailEditForm,
        workDataSource,
        workPgCfg,
        addDataSource,
        searchWorkData,
        setWorkDataSource,
        setSearchWorkData,
        setAddDataSource,
        transformsToPoDetailList,
        setAddModalVisible,
        setWorkPgCfg
    } = usePurchaseRoDetailsModel();
    const { shopAndOrg, user: { roles } } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg])
    const { getRoleColumns } = roleColumnModel();

    const workloadData = async (page?: ISearchPage, searchValue: IPurchaseDetails = searchWorkData) => {
        // let documentTypeCode = mode === "edit" ? detailEditForm.documentTypeCode : detailAddForm.documentTypeCode;
        const { documentTypeCode, bentityCode } = mode === "edit" ? detailEditForm : detailAddForm
        const searchParams = {
            ...searchValue,
            ...shopAndOrg,
            ...sourceAppOrBranch,
            bentityCode,
            pageSize: page?.pageSize ?? workPgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? workPgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { supplierCode, ...params } = searchParams;
        let { retData } = documentTypeCode === DictCodeEnmu.PRETURN_TYPE_GENERAL ? await purchaseRoService.details(searchParams) : await purchaseRoService.details(params);
        const { records, ...pg } = retData;
        const newRecords = records.map(item => {
            return {
                ...item,
                // num: 1,
                returnNum: 1,
                purchasePrice: item.price,
                amount: Number(item.price) * 1,
            }
        })
        setWorkPgCfg(transPgToPagination(pg));
        setWorkDataSource(newRecords);
    }
    useEffect(() => {
        if (visible && mode === "add") {
            workloadData(initPgCfg, { supplierCode: detailAddForm.supplierCode })
            setSearchWorkData({ supplierCode: detailAddForm.supplierCode })
        } else if (visible && mode === "edit") {
            workloadData(initPgCfg, { supplierCode: detailEditForm.supplierCode })
            setSearchWorkData({ supplierCode: detailEditForm.supplierCode })
        }
    }, [detailAddForm.supplierCode, detailEditForm.supplierCode, visible])



    const column = (optype: number) => [
        {
            title: '序号',
            fixed: "left",
            width: 80,
            render: (t: any, r: any, i: number) => <>{i + 1}</>

        }, {
            title: '商品编号',
            width: 120,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '商品名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        },
        {
            title: '规格型号',
            width: 120,
            dataIndex: 'model',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '可用库存',
            width: 100,
            dataIndex: 'availableStock',
        }, {
            title: '采购数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '已退数量',
            width: 100,
            dataIndex: 'preturnNum',
        }, {
            title: '退货数量',
            width: 100,
            dataIndex: 'returnNum',
            editable: true,
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: true,
        }, {
            title: '金额',
            width: 100,
            dataIndex: 'amount',
        }, {
            title: '仓库',
            width: 150,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: string, record: IMaterialDetailModel) => optype === OPT_TYPE.ADD ? (
                <YhBut
                    type="add"
                    txt="添加"
                    click={() => add(record)}
                    disabled={
                        // !!addDataSource.find(item => item.id === record.id)
                        !!addDataSource.find(item => item.id === record.id)
                        || !!(mode === "edit" ? detailDataSource : detailAddList).find(item => item.detailsId === record.id)
                        || record.availableStock === 0
                    }

                />
            ) : (
                <YhBut
                    type="delete"
                    txt="删除"
                    click={() => remove(record)}
                />
            )
        }
    ];
    const newSelectColumns = (optType: number) =>
        column(optType).map((col: any, index) => {
            return {
                ...col,
                onCell: (record: IMaterialDetailModel, rowIndex: number) => ({
                    colIndex: index,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col.editType,
                    editable: col?.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: optType === OPT_TYPE.ADD ? notHandleSave : handleSave,
                }),
            }
        })

    const roleColumns = (optType: number) => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchaseReturn", "roleCodes": roles };
        return getRoleColumns("purchaseReturn", "新增配件", newSelectColumns(optType), params);
    };

    const notHandleSave = (row: IMaterialDetailModel) => {
        let { returnNum, price, preturnNum, num, availableStock } = row
        num = +formatNum(num)
        preturnNum = +formatNum(preturnNum)
        price = +formatNum(price)
        returnNum = +formatIntPoint(returnNum, availableStock, "退货数量>=可用库存数量")

        let newRow = {
            ...row,
            returnNum,
            amount: +formatNum(returnNum * price)
        }
        const index = workDataSource.findIndex((item) => row.id === item.id);
        const item = workDataSource[index];
        workDataSource.splice(index, 1, { ...item, ...newRow });
        setWorkDataSource([...workDataSource])
    }
    const handleSave = (row: IMaterialDetailModel) => {
        let { returnNum, price, preturnNum, num, availableStock } = row
        num = +formatNum(num)
        preturnNum = +formatNum(preturnNum)
        price = +formatNum(price)
        returnNum = +formatIntPoint(returnNum, availableStock, "退货数量>=可用库存数量")
        let newRow = {
            ...row,
            returnNum,
            amount: +formatNum(returnNum * price)
        }
        const index = addDataSource.findIndex((item) => row.id === item.id);
        const item = addDataSource[index];
        addDataSource.splice(index, 1, { ...item, ...newRow });
        setAddDataSource([...addDataSource])
    }
    const allAdd = async (record: any) => {
        let newList: any = []
        record.map((item: any) => {
            if (item.availableStock) {
                newList.push({
                    ...item,
                    returnNum: item.availableStock,
                    note: ""
                })
            }
        })
        setAddDataSource(origin => [...origin, ...newList])
    }
    const add = async (record: IMaterialDetailModel) => {
        setAddDataSource(origin => [...origin, { ...record, note: "" }])
    }
    const remove = async (record: IMaterialDetailModel) => {
        const filterAddDataSource = addDataSource.filter(item => item.id != record.id)
        setAddDataSource(filterAddDataSource)
    }

    const resetWorkloadData = async (params: IPurchaseDetails) => {
        setSearchWorkData({ ...params });
        workloadData(initPgCfg, { ...params });
    }
    const rightChildren = <div className="flex">
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialCode}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value }) }}
            onBlur={(e) => { setSearchWorkData({ ...searchWorkData, materialCode: e.target.value?.trim() }) }}
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder="商品编码"
        />
        <Input
            allowClear
            datatype="round"
            className="border-r-16 mr-10"
            value={searchWorkData.materialName}
            style={{ width: "150px" }}
            onChange={(e) => { setSearchWorkData({ ...searchWorkData, materialName: e.target.value?.trim() }) }}
            onPressEnter={() => workloadData(initPgCfg)}
            placeholder="商品名称"
        />
        <Button onClick={() => workloadData()} style={{ margin: "0px 5px 0px 10px" }} shape="round">检索</Button>
        <Button onClick={() => { mode === "add" ? resetWorkloadData({ supplierCode: detailAddForm.supplierCode }) : resetWorkloadData({ supplierCode: detailEditForm.supplierCode }) }} shape="round">重置</Button>
        <Button type="primary" style={{ margin: "0px 12px 0px 15px" }} onClick={() => allAdd(workDataSource)}>全部添加</Button>
    </div>
    const onOK = async () => {
        transformsToPoDetailList(mode)
        onCancel()
    }
    const onCancel = () => {
        setAddModalVisible(false);
        setAddDataSource([]);
        mode === "add" ? resetWorkloadData({ supplierCode: detailAddForm.supplierCode }) : resetWorkloadData({ supplierCode: detailEditForm.supplierCode })
    };
    return <YHModal
        visible={visible}
        onOk={onOK}
        onCancel={onCancel}
        title="采购退货单-选择配件"
        width={'70%'}
        bodyHeight={730}
        showFooter={true}
    >
        <YhBox title="待选配件列表" rightChildren={rightChildren} style={{ marginBottom: "15px" }}>
            <Table
                bordered
                // size="small"
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.ADD) as ColumnsType<IMaterialDetailModel>}
                dataSource={workDataSource}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                pagination={{
                    ...workPgCfg,
                    pageSizeOptions: ['10', '20', '50', '100', '300', '500'],
                    position: ["bottomCenter"],
                    onChange: (pageNum, pageSize) => {
                        workloadData({ pageNum, pageSize });
                    }
                }}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
        <YhBox title="已选配件列表" style={{ marginBottom: "15px" }}>
            <Table
                bordered
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.id as string}
                columns={roleColumns(OPT_TYPE.REMOVE) as ColumnsType<IMaterialDetailModel>}
                dataSource={[...addDataSource]}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                pagination={false}
                onRow={record => ({
                    onClick: () => { }
                })}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    </YHModal>
}